<script lang="ts">
    export let height;
    // Expects this to be an array of objects, of training statuses. 
    export let training_status_array;
    export let containerStyle ="";
    export let preparedGradientString = "";
    let gradient_string = "";

    function updateGradient(training_status_array) {
        let data = training_status_array

        let _gradient_string = '';

        const e0 = data[0];
        const e1 = data[data.length - 1];
        const t0 = (new Date(e0.date)).getTime()
        const dt = (new Date(e1.date)).getTime() - t0
        data.forEach((element, index) => { // a 1D array 
            if (element && element.color) {
                const t = (new Date(element.date)).getTime()
                const percent = (100.0*(t - t0)/dt).toFixed(1)
                _gradient_string += `${element.color} ${percent}%`;
                if (index != data.length - 1) {
                    _gradient_string += ',';
                }
            }
        });
        gradient_string = _gradient_string;
    }
    $: if (training_status_array) updateGradient(training_status_array)
</script>

<div class="gradient-container" style={containerStyle}>
    <div style={`height:${height}px; background: linear-gradient(90deg, ${training_status_array ? gradient_string : preparedGradientString})`}/>
    <!-- TODO:  -->
</div>


<style lang="scss">
    .gradient-container {
        width: 100%;
    }

</style>